<template>
    <div class="relative inline-block">
        <button @click="openModal" class="info-button" title="Description">
            <img :src="require('@/images/dashboard/info-blue.png')" alt="Info">
        </button>
        <Teleport to="body">
            <div v-if="showModal" class="modal-overlay" @click="closeModal">
                <div class="modal-content" @click.stop>
                    <button class="close-button" @click="closeModal">✖</button>
                    <div class="modal-body" v-html="description"></div>
                </div>
            </div>
        </Teleport>
    </div>
</template>

<script>
export default {
    props: {
        description: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            showModal: false
        };
    },
    methods: {
        openModal() {
            this.showModal = true;
            document.body.style.overflow = "hidden";
        },
        closeModal() {
            this.showModal = false;
            document.body.style.overflow = "";
        }
    }
};
</script>

<style scoped>
.info-button {
    background: none;
    border: none;
    cursor: pointer;
}

.info-button img {
    width: 24px;
    height: 24px;
}

.modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.modal-content {
    background: white;
    padding: 25px;
    border-radius: 8px;
    width: 90%;
    max-width: 900px;
    max-height: 80vh;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 10000;
}

.close-button {
    position: absolute;
    top: 4px;
    right: 4px;
    background: none;
    border: none;
    font-size: 1.2rem;
    cursor: pointer;
}

.modal-body {
    flex-grow: 1;
    font-family: TTNormsMedium, sans-serif;
    overflow-y: auto;
    max-height: calc(80vh - 10px);
    text-align: center;
}
</style>